/** @format */

import {safeDivide} from 'helpers/numberHelpers';

import {ForecastInput, MetricInput, MetricProgress} from '../types';
import {calcMetricForecast} from './calcMetricForecast';
import {aggregateBag} from './aggregateBag';
import {sumSeries, sumSeriesToDate} from './sumSeries';

const readForecastAtEnd = (input: MetricInput): number => {
  const forecastInput: ForecastInput =
    input.kind === 'additive'
      ? {kind: 'additive', factDaily: input.factDaily, forecastDays: input.forecastDays}
      : {
          kind: 'ratio',
          a: input.ratio.a,
          b: input.ratio.b,
          forecastRange: input.ratio.forecastRange,
          forecastDays: input.forecastDays,
        };

  const forecast = calcMetricForecast(forecastInput);
  const list =
    input.kind === 'additive' ? (forecast.secondary ?? forecast.primary) : forecast.primary;

  // sorted[len-1], а не Array.at(-1) — последний не во всех целевых браузерах (browserslist
  // production шире ES2022, полифиллов нет).
  const sortedDays = [...input.forecastDays].sort();
  const endKey = sortedDays[sortedDays.length - 1];

  if (!endKey) {
    return 0;
  }

  const entry = (list as Partial<typeof list>)[endKey];

  return entry?.average ?? 0;
};

export const calcMetricProgress = (input: MetricInput): MetricProgress => {
  if (input.kind === 'additive') {
    const factToDate = sumSeries(input.factDaily);
    const daysWithFact = Object.keys(input.factDaily).length;

    return {
      planForPeriod: sumSeries(input.planDaily),
      planToDate: sumSeriesToDate(input.planDaily, input.today),
      factToDate,
      averageFactPerDay: safeDivide(factToDate, daysWithFact),
      forecastAtEnd: readForecastAtEnd(input),
    };
  }

  const factToDate = input.ratio.bagPredicate(
    aggregateBag(input.ratio.bagByDay, input.ratio.factDays),
  );

  return {
    planForPeriod: input.planForPeriod,
    planToDate: input.planToDate,
    factToDate,
    averageFactPerDay: factToDate,
    forecastAtEnd: readForecastAtEnd(input),
  };
};
